var cell_phone = {};
module['exports'] = cell_phone;
cell_phone.formats = require("./formats");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ja/cell_phone/index.js
// module id = 959
// module chunks = 0